import { createAction } from "redux-act";

export const ConditionBuilderOpenModalAction = createAction("Condition Builder - Open Modal");
export const ConditionBuilderCloseModalAction = createAction("Condition Builder - Close Modal");
